import styled, { css } from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type SidebarPropsT = {
  isSidebarOpened: boolean;
};

const sidebarIsOpenedStyles = css`
  visibility: visible;
  opacity: 1;
  transition: 0.3s linear;
`;

export const SidebarStyled = styled.div<SidebarPropsT>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  height: stretch;
  padding: 2.125rem 0 3.5rem;
  visibility: hidden;
  transition: 0.3s linear;
  background-color: ${({ theme }) => theme.colors.primary.variant1};
  ${({ isSidebarOpened }) => (isSidebarOpened ? sidebarIsOpenedStyles : '')}

  ${({ theme }) => `
    ${theme.devices.tablet} {
      height: 100%;
      padding: 2.125rem 0 2.875rem;
    }
  `}
`;

export const IndentedFlexWrapStyled = styled(FlexContainer)`
  padding: 0 1.875rem;
`;

export const TextStyled = styled(Typography)`
  position: relative;
  margin-left: 0.75rem;
  padding-left: 0.75rem;
  opacity: 0.7;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 2px;
    height: 18px;
    background-color: ${({ theme }) => theme.colors.primary.variant6};
    border-radius: ${({ theme }) => theme.radius.xs};
    opacity: 0.7;
    transform: translateY(-50%);
  }
`;
